<template>
  <div class="card border-radius-none">
    <div class="columns is-marginless is-paddingless is-multiline card-article">
      <div class="column is-12 is-paddingless">
        <div class="card-article-input-icon">
          &nbsp;
        </div>
        <div class="card-article-input-product-large mgb-10px mgt-10px">&nbsp;</div>
        <div class="card-article-input-libelle-remise mgb-10px">
          <b-field custom-class="is-size-7 is-marginless has-text-link"
                   :label="$t('detail.article.libelle')">
            <span >{{ ligneCommande.libelle }}
            </span>
          </b-field>
        </div>

        <div class="card-article-input-remise-soustotal">
          <div class="ellipsis card-article-input-price-remise float-right mgt-30px">
            &nbsp;
          </div>
        </div>

        <div class="card-article-input-remise-quantite">
          &nbsp;
        </div>

        <div class="float-right mgt-25px mgr-20px is-invisible">
          <b-icon
              icon="arrow-right-drop-circle"
              type="is-default"
            >
          </b-icon>
        </div>
        <div class="has-text-weight-semibold mgt-30px float-right
          card-article-input-price-general right">
          <span v-if="ligneCommande.totalHt">
            {{ligneCommande.totalHt | formatDevise}}
          </span>
          <span v-else> {{ 0.00 | formatDevise }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ligneRemiseProduit',
  props: {
    ligneCommande: Object,
  },
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>
